import React, { Component } from 'react';
import {
  Modal,
  Icon,
  Input,
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import { Scrollbars } from 'react-custom-scrollbars-2';
import cx from 'classnames';
import api from '../../api';
import searchIcon from '../../images/common/search_icon.png';
import Loader from '../Loader/Loader';
import closeBtn from '../../images/components/new_scan/close-btn.svg';
import clearBtn from '../../images/components/tag/smallCloseBtn.png';
import TreeNode from '../TreeView/TreeNode';

class DependencyModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      treeData: [],
      isLoading: false,
      isExpandedAll: false,
      searchKeyword: '',
      searchPerformed: false,
    };
    this.handleClearSearch = this.handleClearSearch.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearchEnter = this.handleSearchEnter.bind(this);
    this.toggleTreeNode = this.toggleTreeNode.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {
      isOpenMDP,
    } = this.props;
    if (isOpenMDP !== prevProps.isOpenMDP) {
      this.setState({
        treeData: [],
        searchKeyword: '',
        searchPerformed: false,
        isLoading: false,
        isExpandedAll: false,
      }, () => {
        if (isOpenMDP) {
          this.getPackageDependency();
        }
      });
    }
  }

  handleSearchChange(e, { value }) {
    this.setState({
      searchKeyword: value.trim(),
      searchPerformed: false,
    });
  }

  handleSearchEnter(event) {
    const { searchKeyword } = this.state;
    if (event.key === 'Enter' && searchKeyword.trim() !== '') {
      this.setState({
        searchPerformed: true,
      });
    }
  }

  handleClearSearch = () => {
    this.setState({
      searchKeyword: '',
      searchPerformed: false,
    });
  };

  getPackageDependency() {
    const { uploadedFileId, scannedFileId } = this.props;

    this.setState({
      isLoading: true,
    });

    api
      .getPackageDependency(uploadedFileId, scannedFileId)
      .then((response) => {
        const o = response.response;
        const nextTreeData = o.map((item) => {
          return {
            component_name: item.component_name,
            component_version: item.component_version,
            dependencies: item.dependencies,
            extras: item.extras,
          };
        });

        this.setState({
          treeData: nextTreeData,
          isLoading: false,
        });
      })
      .catch((err) => {
        console.error(err);
        this.setState({
          isLoading: false,
        });
      });
  }

  toggleTreeNode() {
    const { isExpandedAll } = this.state;
    this.setState({
      isExpandedAll: !isExpandedAll,
    });
  }

  closeModal(e) {
    const { closeModal } = this.props;
    if (e.target.classList[0] === 'fold_icon' || e.target.classList[0] === 'expand_icon') {
      return;
    }
    closeModal();
  }

  render() {
    const {
      isLoading, treeData, isExpandedAll, searchKeyword, searchPerformed
    } = this.state;
    const { translate, scannedFileName, isOpenMDP } = this.props;

    return (
      <Modal
        open={isOpenMDP}
        onClose={this.closeModal}
      >
        <div className="setting_popup_wrap dependency">
          <div className="setting_popup default_popup">
            <div className="setting_popup_header">
              <h2 className="popup_name">
                <span>{translate('modal.title.all_dependencies')}</span>
              </h2>
              <a
                className="popup_close_button"
                style={{ cursor: 'pointer' }}
                onClick={this.closeModal}
                onKeyUp={this.closeModal}
              >
                <img src={closeBtn} alt="" />
              </a>
            </div>
            <div className="util_wrap">
              <div className="search_box">
                <Input
                  className="text left icon"
                  placeholder={translate('contents_header.place_holder.component_name')}
                  onChange={this.handleSearchChange}
                  onKeyPress={this.handleSearchEnter}
                  value={searchKeyword}
                >
                  <span className="search_icon">
                    <img src={searchIcon} alt="" />
                  </span>
                  <input />
                </Input>
                <div
                  className={cx('btn-close', {
                    active: searchKeyword !== '',
                  })}
                  onClick={this.handleClearSearch}
                  onKeyUp={this.handleClearSearch}
                  name="close"
                >
                  <img src={clearBtn} alt="" />
                </div>
              </div>
              <div className="button_wrap">
                {
                  isExpandedAll ? (
                    <a
                      className="collapse_button"
                      onClick={this.toggleTreeNode}
                      onKeyUp={this.toggleTreeNode}
                    >
                      <Icon name="minus" />
                      {translate('settings.button.collapse_all')}
                    </a>
                  ) : (
                    <a
                      className="expand_button"
                      onClick={this.toggleTreeNode}
                      onKeyUp={this.toggleTreeNode}
                    >
                      <Icon name="plus" />
                      {translate('settings.button.expand_all')}
                    </a>
                  )
                }
              </div>
            </div>
            {
              isLoading ? (
                <Loader />
              ) : (
                <div className="dependency_tree">
                  <div className="header_wrap">
                    <div className="title" style={{ marginBottom: '7px' }}>
                      <span>
                        <Icon className="file outline" />
                        {scannedFileName}
                      </span>
                    </div>
                  </div>
                  <Scrollbars
                    renderTrackHorizontal={() => {
                      return <div />;
                    }}
                    renderThumbHorizontal={() => {
                      return <div />;
                    }}
                    autoHeight
                    autoHeightMin={430}
                    autoHeightMax={430}
                  >
                    <div className="tree_container">
                      {
                        treeData.map((item) => {
                          return (
                            <TreeNode
                              key={uuidv4()}
                              node={item}
                              isExpandedAll={isExpandedAll}
                              searchKeyword={searchKeyword}
                              searchPerformed={searchPerformed}
                              translate={translate}
                            />
                          );
                        })
                      }
                    </div>
                  </Scrollbars>
                </div>
              )
            }
            <div className="setting_popup_button_wrap" style={{ padding: 0 }}>
              <a
                className="button center_button"
                style={{ cursor: 'pointer' }}
                onClick={this.closeModal}
                onKeyUp={this.closeModal}
              >
                {translate('modal.button.close')}
              </a>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default DependencyModal;
